var map = {
	"./auth/index.js": "qwCr",
	"./index.js": "8/uM",
	"./layouts/index.js": "YiCS",
	"./pages/campus-recruiting.js": "PplW",
	"./pages/career-counselling.js": "E6nK",
	"./pages/enterprise-visits.js": "Tl8s",
	"./pages/enterprises.js": "xMZ0",
	"./pages/faqs.js": "3inr",
	"./pages/home.js": "97Pa",
	"./pages/intern.js": "mSLf",
	"./pages/job-openings.js": "pMQ9",
	"./pages/jobs.js": "jGBb",
	"./pages/lectures.js": "IqYf",
	"./pages/news.js": "P9+9",
	"./pages/point.js": "xtgT",
	"./pages/promotion-links.js": "DZmC",
	"./pages/students.js": "Jk0a",
	"./pages/teachers.js": "AbWv",
	"./pages/ucan.js": "iY+p"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TyaN";